import { Component } from '@angular/core';

@Component({
    selector: 'seller', template: '<router-outlet></router-outlet>',
    standalone: false
})
export class SchedulerComponent {}
